var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeh = function SvgMeh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.398c5.854 0 10.6 4.746 10.6 10.6s-4.746 10.6-10.6 10.6-10.6-4.746-10.6-10.6 4.746-10.6 10.6-10.6m0 1.2a9.4 9.4 0 1 0 0 18.8 9.4 9.4 0 0 0 0-18.8m4 11.9a.5.5 0 0 1 0 1H8a.5.5 0 1 1 0-1zm-6.991-6a.5.5 0 0 1 0 1h-.01a.5.5 0 0 1 0-1zm6 0a.5.5 0 0 1 0 1h-.01a.5.5 0 0 1 0-1z"
  })));
};
export default SvgMeh;